import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./index.scss";

export default function Loading() {
  const navigate = useNavigate();

  useEffect(() => {
    const localUser = JSON.parse(localStorage.getItem("userData"));

    if (localUser && localUser.token) {
      setTimeout(() => navigate("/dashboard", { replace: true }), 800);
    } else {
      navigate("/login", { replace: true });
    }
  }, []);

  return (
    <div className="loading">
      <div className="container">
        <h2>جارى التحميل</h2>
        <div className="dots">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
          <span></span>
        </div>
      </div>
    </div>
  );
}
